import { Grid, GridProps } from "@chakra-ui/react";
import React, { FocusEventHandler } from "react";
import { InputWithValidationControl } from "src/components/Inputs/InputWithValidationControl";
import { NameFormType } from "src/schemas/Name";
import { PASSWORD_MANAGER_IGNORE } from "src/types/passwordManager";
import { BirthDateField } from "./BirthDateField";

type Props = {
  onFocus?: FocusEventHandler;
  firstName?: { label?: string };
  middleName?: { label?: string };
  lastName?: { label?: string };
  hide?: Array<keyof NameFormType>;
  isDisabled?: boolean;
  // Opt in to the required-field asterisk. Off by default to preserve the existing
  // no-asterisk convention across the app (parent portal, edit pages, etc.).
  showRequiredIndicator?: boolean;
} & GridProps;
export const NameForm: React.FC<Props> = ({
  onFocus = () => {},
  firstName,
  middleName,
  lastName,
  hide,
  isDisabled = false,
  showRequiredIndicator = false,
  ...props
}) => (
  <Grid
    gridTemplateColumns="repeat(auto-fit, minmax(15rem, 1fr))"
    gap={3}
    alignItems="flex-end"
    {...props}
  >
    {!hide?.includes("first_name") && (
      <InputWithValidationControl
        inputProps={{ placeholder: "E.g.: Alex", ...PASSWORD_MANAGER_IGNORE }}
        name="first_name"
        id="first_name"
        label={firstName?.label ?? "First name"}
        isRequired={true}
        labelProps={
          showRequiredIndicator ? undefined : { requiredIndicator: <></> }
        }
        onFocus={onFocus}
        isDisabled={isDisabled}
      />
    )}
    {!hide?.includes("middle_name") && (
      <InputWithValidationControl
        isRequired={false}
        inputProps={{ placeholder: "E.g.: Dan", ...PASSWORD_MANAGER_IGNORE }}
        name="middle_name"
        id="middle_name"
        label={`${middleName?.label ?? "Middle name"} (Optional)`}
        onFocus={onFocus}
        isDisabled={isDisabled}
      />
    )}
    {!hide?.includes("last_name") && (
      <InputWithValidationControl
        inputProps={{ placeholder: "E.g.: Doe", ...PASSWORD_MANAGER_IGNORE }}
        name="last_name"
        id="last_name"
        label={lastName?.label ?? "Last name"}
        isRequired={true}
        labelProps={
          showRequiredIndicator ? undefined : { requiredIndicator: <></> }
        }
        onFocus={onFocus}
        isDisabled={isDisabled}
      />
    )}
    {!hide?.includes("birth_date") && (
      <BirthDateField
        showRequiredIndicator={showRequiredIndicator}
        onFocus={onFocus}
        isDisabled={isDisabled}
      />
    )}
  </Grid>
);
